import { PageHeader } from "../components/layout/PageHeader";
import { WhyChooseUs } from "../components/home/WhyChooseUs";
import { EditorialMarquee } from "../components/home/EditorialMarquee";
import { CTASection } from "../components/home/CTASection";
import { IMG } from "../data/content";

export default function WhyChooseUsPage() {
  return (
    <main data-testid="why-page">
      <PageHeader
        eyebrow="Why Choose Us"
        title="One professional partner for reliable property support."
        subtitle="A proudly South African, 100% Black-owned Level 1 B-BBEE company delivering dependable, high-quality services with a customer-focused approach."
        image={IMG.manicured}
      />
      <WhyChooseUs heading={false} />
      <EditorialMarquee />
      <CTASection />
    </main>
  );
}
